import { init as initTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { init as initWeb } from '@cian/web/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { initMicrofrontend } from '@cian/mf-registry-legacy/browser';
import { initConfigUnsafe } from '@cian/config/browser';

export function initDependencies() {
  initConfigUnsafe();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalBehaviors();
  initMicrofrontend();
}
